export default __webpack_public_path__ + "static/media/dfl-vid-1.bb0af494.mp4";